import { useState } from 'react';
import { Link } from 'react-router-dom';
import {  Search, Globe, Menu, X } from 'lucide-react';
// import { Shield, Moon, Sun, Search, Globe, Menu, X } from 'lucide-react';
import { useTranslation } from '../../TranslationContext';

const Navbar0 = () => {
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { currentLanguage, setLanguage, t } = useTranslation();

  // Custom color palette
  const colors = {
    roseRed: '#c06a70',
  };

  // const toggleTheme = () => {
  //   setIsDarkMode(!isDarkMode);
  //   document.documentElement.classList.toggle('dark');
  // };

  const languages = [
    { code: 'EN', label: 'English' },
    { code: 'FR', label: 'Français' },
    { code: 'ES', label: 'Español' },
  ];

  const navLinks = [
    { to: '/About', label: t('about') },
    { to: '/Sales', label: t('sales') },
    { to: '/Articles', label: t('articles') },
    { to: '/Support', label: t('support') },
    { to: '/Contact', label: t('contact') },
  ];

  return (
    <nav style={{ backgroundColor: colors.roseRed }} className="shadow-lg transition-colors duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo and Brand */}
          <div className="flex items-center">
            {/* <Link to="/" className="flex items-center">
              <Shield className="h-6 w-6 sm:h-8 sm:w-8 text-white" />
              <span className="ml-2 text-xl sm:text-2xl font-bold text-white">
                {t('app_name')}
              </span>
            </Link> */}
            <Link to="/" className="flex items-center">
                    <img src="/logoOtentiNew.png" alt="Logo" className="h-9 w-9 sm:h-11 sm:w-11" />
                    <span className="ml-2 text-xl sm:text-2xl font-bold text-white">
              {t('app_name')}
            </span>
           </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center">
            <div className="flex space-x-4 mr-4">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="font-medium text-white hover:text-gray-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Desktop Controls */}
            <div className="flex items-center space-x-2">
              <Link 
                to="/SearchPage" 
                className="p-2 rounded-md text-white transition-colors link"
              >
                <Search className="h-5 w-5 text-white" />
              </Link>

              {/* Language Selector */}
              <div className="relative">
                <button
                  onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
                  className="flex items-center p-2 rounded-md text-white button-hover"
                >
                  <Globe className="h-5 w-5 text-white" />
                  <span className="ml-2 text-sm text-white">{currentLanguage}</span>
                </button>

                {isLanguageMenuOpen && (
                  <div 
                    className="absolute right-0 mt-2 w-48 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50" 
                    style={{ backgroundColor: colors.roseRed }}
                  >
                    <div className="py-1" role="menu" aria-orientation="vertical">
                      {languages.map((language) => (
                        <button
                          key={language.code}
                          onClick={() => {
                            setLanguage(language.code as 'EN' | 'FR' | 'ES');
                            setIsLanguageMenuOpen(false);
                          }}
                          className="block px-4 py-2 text-sm w-full text-left text-white hover:bg-opacity-80 button-hover"
                          role="menuitem"
                        >
                          {language.label}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Theme Toggle */}
              {/* <button
                onClick={toggleTheme}
                className="p-2 rounded-md"
                style={{ backgroundColor: isDarkMode ? '#a05a60' : '#d07a80' }}
              >
                {isDarkMode ? (
                  <Sun className="h-5 w-5 text-white" />
                ) : (
                  <Moon className="h-5 w-5 text-white" />
                )}
              </button> */}
            </div>
          </div>

          {/* Mobile Controls */}
          <div className="flex md:hidden items-center space-x-2">
            {/* Language Selector */}
            <div className="relative">
              <button
                onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
                className="flex items-center p-2 rounded-md text-white"
              >
                <Globe className="h-5 w-5 text-white" />
                <span className="ml-1 text-sm text-white">{currentLanguage}</span>
              </button>

              {isLanguageMenuOpen && (
                <div 
                  className="absolute right-0 mt-2 w-48 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50"
                  style={{ backgroundColor: colors.roseRed }}
                >
                  <div className="py-1">
                    {languages.map((language) => (
                      <button
                        key={language.code}
                        onClick={() => {
                          setLanguage(language.code as 'EN' | 'FR' | 'ES');
                          setIsLanguageMenuOpen(false);
                        }}
                        className="block px-4 py-2 text-sm w-full text-left text-white hover:bg-opacity-80 button-hover"
                      >
                        {language.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Theme Toggle */}
            {/* <button
              onClick={toggleTheme}
              className="p-2 rounded-md"
              style={{ backgroundColor: isDarkMode ? '#a05a60' : '#d07a80' }}
            >
              {isDarkMode ? (
                <Sun className="h-5 w-5 text-white" />
              ) : (
                <Moon className="h-5 w-5 text-white" />
              )}
            </button> */}

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2 rounded-md text-white"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1" style={{ backgroundColor: '#a05a60' }}>
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block px-3 py-2 rounded-md text-base font-medium text-white hover:text-gray-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              
              <Link 
                to="/SearchPage" 
                className="flex items-center space-x-2 px-3 py-2 rounded-md text-white hover:text-gray-200"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Search className="h-5 w-5" />
                <span>{t('search')}</span>
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar0;
